// Author Lin
// Date 2024-06-05 16:34:40

class SithMesInventoryBinStatus {
    constructor({
                    id = null,
                    storageType = '',
                    storageBin = '',
                    material = '',
                    batch = '',
                    specialStock = '',
                    specialStockNumber = '',
                    baseUnit = '',
                    availableStock = '',
                    plant = '',
                    totalStock = '',
                    quant = '',
                    grDate = '',
                    maxWeight = '',
                    maxWeightUnit = '',
                    grNumber = '',
                    weight = '',
                    weightUnit = '',
                    trNumber = '',
                    storageLoc = '',
                    lastMovement = '',
                    documentNumber = '',
                    occupiedCapacity = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.storageType = storageType;
        this.storageBin = storageBin;
        this.material = material;
        this.batch = batch;
        this.specialStock = specialStock;
        this.specialStockNumber = specialStockNumber;
        this.baseUnit = baseUnit;
        this.availableStock = availableStock;
        this.plant = plant;
        this.totalStock = totalStock;
        this.quant = quant;
        this.grDate = grDate;
        this.maxWeight = maxWeight;
        this.maxWeightUnit = maxWeightUnit;
        this.grNumber = grNumber;
        this.weight = weight;
        this.weightUnit = weightUnit;
        this.trNumber = trNumber;
        this.storageLoc = storageLoc;
        this.lastMovement = lastMovement;
        this.documentNumber = documentNumber;
        this.occupiedCapacity = occupiedCapacity;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesInventoryBinStatus();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.projectCode',
            sortable: false,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageType',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.storageType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageBin',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.storageBin',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'material',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.material',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDesc',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.materialDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'batch',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.batch',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'specialStock',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.specialStock',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'specialStockNumber',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.specialStockNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'baseUnit',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.baseUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'availableStock',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.availableStock',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'plant',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.plant',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'totalStock',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.totalStock',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quant',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.quant',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'grDate',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.grDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'maxWeight',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.maxWeight',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'maxWeightUnit',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.maxWeightUnit',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'grNumber',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.grNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'weight',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.weight',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'weightUnit',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.weightUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'trNumber',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.trNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageLoc',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.storageLoc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'lastMovement',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.lastMovement',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'documentNumber',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.documentNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'occupiedCapacity',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.occupiedCapacity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'lastCountTime',
            label: 'label.sith.inventory.sithMesInventoryBinStatus.grid.lastCountTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    storageTypeFilter: '',
    storageBinFilter: '',
    materialFilter: '',
    materialDescFilter: '',
    batchFilter: '',
    specialStockFilter: '',
    specialStockNumberFilter: '',
    baseUnitFilter: '',
    availableStockFilter: '',
    plantFilter: '',
    totalStockFilter: '',
    quantFilter: '',
    grDateRteFilter: '',
    grDateLteFilter: '',
    maxWeightFilter: '',
    maxWeightUnitFilter: '',
    grNumberFilter: '',
    weightFilter: '',
    weightUnitFilter: '',
    trNumberFilter: '',
    storageLocFilter: '',
    lastMovementRteFilter: '',
    lastMovementLteFilter: '',
    documentNumberFilter: '',
    occupiedCapacityFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'storageTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.storageType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageBinFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.storageBin',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.material',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialDescFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.materialDesc',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batchFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.batch',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specialStockFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.specialStock',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specialStockNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.specialStockNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseUnitFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.baseUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'availableStockFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.availableStock',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plantFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.plant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'totalStockFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.totalStock',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.quant',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'grDateRteFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.grDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'grDateLteFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.grDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'grNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.grNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weightFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.weight',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weightUnitFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.weightUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLocFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.storageLoc',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastMovementRteFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.lastMovementRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastMovementLteFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.lastMovementLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'documentNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.documentNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'occupiedCapacityFilter',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.filter.occupiedCapacity',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.storageType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageBin',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.storageBin',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'material',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.material',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'batch',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.batch',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specialStock',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.specialStock',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specialStockNumber',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.specialStockNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'baseUnit',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.baseUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'availableStock',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.availableStock',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'plant',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.plant',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'totalStock',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.totalStock',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quant',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.quant',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'grDate',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.grDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'maxWeight',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.maxWeight',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'maxWeightUnit',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.maxWeightUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'grNumber',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.grNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weight',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.weight',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'weightUnit',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.weightUnit',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'trNumber',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.trNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageLoc',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.storageLoc',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'lastMovement',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.lastMovement',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'documentNumber',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.documentNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'occupiedCapacity',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.occupiedCapacity',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryBinStatus.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesInventoryBinStatus, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
